export default "__VITE_ASSET__32c32ee3__"